export const getCurrentWizardStepIndex = (state) => {
    return state.hartfordImportHoldings.currentWizardStepIndex;
};
export const getPortfolioImportType = (state) => {
    return state.hartfordImportHoldings.portfolioImportType;
};
export const getSelectedClient = (state) => {
    return state.hartfordImportHoldings.selectedClient;
};
export const getSelectedMatrices = (state) => {
    return state.hartfordImportHoldings.selectedMatrices;
};
export const getSelectedMatrixIds = (state) => {
    return state.hartfordImportHoldings.selectedMatrices.map((m) => m.id);
};
export const getClientResultsLoaded = (state) => {
    return state.hartfordImportHoldings.clientResultsLoaded;
};
export const getMatrixResultsLoaded = (state) => {
    return state.hartfordImportHoldings.matrixResultsLoaded;
};
